module.exports = __webpack_public_path__ + "img/card-half-transparent.27ceb11.png";